export default class FrendsElementTooltip {
    tooltips: Tooltips;
    eventBus: any;
    currentTooltipId: string;
    activeElement: BpmnJsElement;

    constructor(eventBus: any, tooltips: Tooltips) {
        this.eventBus = eventBus;
        this.tooltips = tooltips;
        this.tooltips._init();
        eventBus.on('element.out', (event: any) => { this.onElementOut(event) });
    }

    onElementOut = function (event: any) {
        if (this.activeElement && this.currentTooltipId && event.element == this.activeElement) //If there's a tooltip set to the element we're leaving, activate fade timer for it:
        {
            const tooltip = this.tooltips.get(this.currentTooltipId);
            if (tooltip) {
                tooltip.timeout = 500;
                this.tooltips.setTimeout(tooltip);
            }
        }
    }

    setTooltipMessage = function (message: string | undefined, element: BpmnJsElement) {
        if (message && message.length > 0) {
            if (this.activeElement === element && this.tooltips.get(this.currentTooltipId) != null) {
                // don't show if there's already a tooltip for the element, e.g. a validation message and description both exist
                return;
            }
            const tooltipContainer =
                '<div class="bpmn-hover-tooltip">\
                        <div class="tooltip top in">\
                            <div class="tooltip-inner">'+
                message + '\
                            </div>\
                        </div>\
                    </div>';
            const tooltipId = this.tooltips.add({
                position: {
                    x: element.x !== undefined && element.width !== undefined && element.x + element.width / 2,
                    y: element.y
                },
                html: tooltipContainer,
                timeout: 4000 //Set a long timeout that causes the tooltip to fade eventually in case the element.out event does not fire for some reason, that way it will eventually fade.
            } as Tooltip);
            this.activeElement = element;
            this.currentTooltipId = tooltipId;
        }
    }
}

FrendsElementTooltip.$inject = ['eventBus', 'tooltips'];
